<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="type-of-cover"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row label="What type of cover would you like?">
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_type-of-cover`"
          name="Type of Cover"
          rules="required"
          tag="div"
        >
          <radio
            v-model="questionData.typeOfCover"
            :name="`${stepId}-type-of-cover`"
            :data-test="snakeCase(questionFields.typeOfCover)"
            :items="typeOfCoverOptions"
            :error="failed"
            column
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

export default {
  name: 'question-type-of-cover',
  extends: QuestionBase,
  props: {
    defaultValues: {
      type: Object,
      default () {
        return { typeOfCover: 1 };
      },
    },
  },
  data () {
    return {
      fields: ['typeOfCover'],
    };
  },
  computed: {
    typeOfCoverOptions () {
      return this.helpers.createOptions({
        source: this.constants.COVER_TYPE_OF_COVER,
        asNumbers: true,
      }).map(item => ({
        ...item,
        helpText: this.constants.COVER_TYPE_OF_COVER_DESCRIPTION[item.value],
      }));
    },
  },
};
</script>
